import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
// import { TimesheetService } from '../Service/TimesheetService';
import { TimesheetService } from '../Services/timesheet.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { forkJoin } from 'rxjs';
interface NonBillTask {
  Taskname: string;
  TaskId: number;
}

interface DayDetails {
  TimesheetDate: string;
  Hours: number | string; // Using string to allow for easy ngModel binding, consider number if more appropriate
  Comments: string;
}

interface Project {
  UserID: number;
  UserName: string;
  UserEmail: string;
  ProjectID: string;
  ProjectName: string;
  TaskID: string;
  TaskName: string;
  TimeCode: string;
  comment: string;
  StartWeek: Date;
  EndWeek: Date;
  Hours: number;
  IsBillable: string;
  showTaskOptions: boolean;
  TaskOptions: [];
  RecordStatus: string;
  unavailable: boolean;

  // Add empty placeholders for each day of the week
  // days: { [key: string]: string };
  TaskDetails: { [key: string]: DayDetails };
}

interface TransformDataResult {
  billable: Project[];
  nonBillable: Project[];
}

@Component({
  selector: 'app-timesheet-portal',
  templateUrl: './timesheet-portal.component.html',
  styleUrls: ['./timesheet-portal.component.css'],
  providers: [ConfirmationService, MessageService]
})
export class TimesheetPortalComponent implements OnInit {
  // @ViewChild('inputHour', { static: false }) inputHour: ElementRef | undefined;
  rowDisabledStates: { [key: string]: boolean } = {};
  projects: Project[] = [];
  nonBillprojects: Project[] = [];
  weekDays: string[] = [];
  nonBillweekDays: string[] = [];
  billableOptions: any[] = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' }
  ];
  demoOptions: any[] = []
  TaskOptions: any[] = []

  currentDate: Date = new Date();
  visible: boolean = false;
  nonBillvisible: boolean = false;

  tempHours: string = '';
  tempComment: string = '';
  currentProject: any = null;
  currentDay: string = '';
  storedLoginData: any;
  LoginData: any;
  LoggedInUserId: any;
  LoggedInUserEmail: any;
  LoggedInUserName: any;
  selectedProject: string = '';
  filteredTasks: any[] = [];
  // projectsAndTasks = new Map();
  Startweek: any;
  Endweek: any;
  nonbillTasks: NonBillTask[] | any;
  formattedDate: any;
  showLoader: boolean = false;
  MessageVisible: boolean = false;
  alertVisible: boolean = false;
  warningVisible: boolean = false;
  emptyRowWarningVisible: boolean = false;
  hourWarningVisible: boolean = false;
  startDate: any
  FinishDate: any;
  formattedStartweek: any
  formattedStartDate: any
  formattedendweek: any
  formattedendDate: any
  isInputDisabled: boolean = true;
  newRow: boolean = false;
  formattedWeekDaysbillable: string[] = [];
  formattedWeekDaysNonbillable: string[] = [];

  configData: any;
  serverTime: any;
  isDataProcessing: any;
  dataProcessingNote: any;

  // Add this getter here, at the class level
  get isSubmitEnabled(): boolean {
    // const allRows = [...this.projects, ...this.nonBillprojects];

    // // Only consider rows that actually have data from DB
    // const savedRows = allRows.filter(row => 
    //   row.TaskID !== '' && row.TaskID !== null && row.TaskID !== undefined
    // );

    // return savedRows.length > 0 
    //   && savedRows.every(row => row.RecordStatus?.trim() === 'Pending'|| row.RecordStatus?.trim() === "");
    if (this.isDataProcessing != 'Yes') {
      return true;
    }
    else {
      return false
    }
  }

  get canAddTask(): boolean {
    // const allRows = [...this.projects, ...this.nonBillprojects];

    // const savedRows = allRows.filter(row => 
    //   row.TaskID !== '' && row.TaskID !== null && row.TaskID !== undefined
    // );

    // // No saved rows → always allow adding
    // if (savedRows.length === 0) return true;

    // // Has rows → only allow if all are Pending
    // return savedRows.every(row => row.RecordStatus?.trim() === 'Pending' || row.RecordStatus?.trim() === "");
    if (this.isDataProcessing != 'Yes') {
      return true;
    }
    else {
      return false
    }
  }

  constructor(private datePipe: DatePipe, private TimesheetService: TimesheetService, private dialogService: DialogService,
    private cdr: ChangeDetectorRef, private messageService: MessageService, private confirmationService: ConfirmationService) {
    this.weekDays = this.getWeekDays(this.currentDate);
    this.nonBillweekDays = this.getWeekDays(new Date());
  }
  TaskOption: any
  // ngOnInit() {
  //   this.showLoader = true;
  //   this.storedLoginData = localStorage.getItem('loginDetails');

  //   if (this.storedLoginData !== null) {
  //     this.LoginData = JSON.parse(this.storedLoginData);
  //      this.LoggedInUserId = this.LoginData[0].id;
  //     this.LoggedInUserEmail = this.LoginData[0].email;
  //     this.LoggedInUserName = this.LoginData[0].name;
  //   }

  //   this.getTimesheet(this.LoggedInUserId, this.Startweek, this.Endweek)

  //   this.TimesheetService.GetTasks(this.LoggedInUserId).subscribe((res: any) => {
  //     // Sort the data alphabetically by project name, then by task name
  //     res.data.sort((a: any, b: any) => {
  //       let comparison = a.project.data.name.localeCompare(b.project.data.name);
  //       if (comparison === 0) {
  //         return a.name.localeCompare(b.name);
  //       }
  //       return comparison;
  //     });

  //     let projectsAndTasks = new Map();

  //     res.data.forEach((element: any) => {
  //       let ProjectName = element.project.data.name;
  //       let ProjectId = element.project.data.id;
  //       let Task = element.name;
  //       let TaskId = element.id;
  //       this.startDate = element.plannedStart;
  //       this.FinishDate = element.plannedFinish;

  //       if (!projectsAndTasks.has(ProjectName)) {
  //         projectsAndTasks.set(ProjectName, []);
  //       }

  //       let tasksForProject = projectsAndTasks.get(ProjectName);
  //       if (!tasksForProject.some((task: { value: any; }) => task.value === TaskId)) {
  //         // Add the task to the project's array if it doesn't already exist
  //         this.TaskOption = tasksForProject.push({
  //           label: Task,
  //           value: parseInt(TaskId)
  //         });
  //       }
  //     });


  //     this.demoOptions = Array.from(projectsAndTasks.entries()).map(([key, value]) => {
  //       const projectData = res.data.find((item: { project: { data: { name: string; }; }; }) => item.project.data.name === key);
  //       const projectId = projectData ? projectData.project.data.id : null; // Project ID
  //       return {
  //         label: key,
  //         value: parseInt(projectId),
  //         tasks: value
  //       };
  //     });

  //     if (this.projects.length != 0) {
  //       // //   this.onProjectChange(this.projects[0].ProjectID, this.projects[0]);
  //       // const selectedProject = this.demoOptions.find(option => option.value === this.projects[0].ProjectID);
  //       // let selectedProjectTasks: any;
  //       // if (selectedProject) {
  //       //   selectedProjectTasks = selectedProject.tasks;
  //       // }
  //       // this.TaskOptions = [];
  //       // this.TaskOptions = selectedProjectTasks;

  //       this.projects.forEach((project) => {
  //         // const projectData = projectsAndTasks.get(project.ProjectID); // Assuming ProjectName is available
  //         const projectData = this.demoOptions.find(option => option.value === project.ProjectID);
  //         if (projectData) {
  //           // Directly set the tasks for this specific project
  //           project.TaskOptions = projectData.tasks;
  //           // this.showLoader = false;
  //         }
  //         else {
  //           // Project is no longer assigned to this user — handle gracefully
  //           project.TaskOptions = [];
  //           // this.showLoader = false;
  //         }
  //         this.showLoader = false;
  //       });
  //     } else {
  //       this.addNewProject();
  //        this.showLoader = false;
  //     }

  //     if (this.nonBillprojects.length == 0) {
  //       this.addNewNonBillProject();
  //        this.showLoader = false;
  //     }
  //     // this.showLoader = false;
  //   });
  //   this.getNonBillOptions();
  //   this.getAppConfiguration();
  //   // this.nonbillTasks = [
  //   //   { Taskname: 'On Bench', TaskId: 178397 },
  //   //   { Taskname: 'Training', TaskId: 178406 },
  //   //   { Taskname: 'Leave', TaskId: 179469 },
  //   //   { Taskname: 'Pre-dev Activities', TaskId: 179847 }
  //   // ];
  //   this.projects = [];
  //   this.nonBillprojects = [];
  //   this.calculateNonBillTotalHours()
  //   this.calculateTotalHour()

  //   this.formatDatesbillable()
  //   this.formatDatesNonbillable()
  // }

  //NEW IMPLEMENTATION INTRODUCED TO DEAL WITH UNASSIGNED ProjectId ERROR and ELIMINATE POSSIBLE RACE CONDITIONS
  ngOnInit() {
    this.showLoader = true;
    this.projects = [];
    this.nonBillprojects = [];

    this.storedLoginData = localStorage.getItem('loginDetails');
    if (this.storedLoginData !== null) {
      this.LoginData = JSON.parse(this.storedLoginData);
      this.LoggedInUserId = this.LoginData[0].id;
      this.LoggedInUserEmail = this.LoginData[0].email;
      this.LoggedInUserName = this.LoginData[0].name;
    }

    //if any one of the three calls fails, none of the next logic runs
    //API calls complete before do any matching — this eliminates the race entirely
    forkJoin({
      timesheet: this.TimesheetService.GetTimeSheet(this.LoggedInUserId, this.Startweek, this.Endweek),
      tasksRes: this.TimesheetService.GetTasks(this.LoggedInUserId),
      nonBillRes: this.TimesheetService.getNonBillOptions()
    }).subscribe({
      next: (result: any) => {
        const timesheet = result.timesheet;
        const tasksRes = result.tasksRes;
        const nonBillRes = result.nonBillRes;

        //  non-bill options, must be ready BEFORE transformData runs 
        this.nonbillTasks = nonBillRes.Data.map((item: { NonBillableTask: any; TaskID: any; }) => ({
          Taskname: item.NonBillableTask,
          TaskId: item.TaskID
        }));

        //  build demoOptions from tasksRes 
        const res = tasksRes;
        res.data.sort((a: any, b: any) => {
          let comparison = a.project.data.name.localeCompare(b.project.data.name);
          if (comparison === 0) {
            return a.name.localeCompare(b.name);
          }
          return comparison;
        });

        let projectsAndTasks = new Map();

        res.data.forEach((element: any) => {
          let ProjectName = element.project.data.name;
          let Task = element.name;
          let TaskId = element.id;
          this.startDate = element.plannedStart;
          this.FinishDate = element.plannedFinish;

          if (!projectsAndTasks.has(ProjectName)) {
            projectsAndTasks.set(ProjectName, []);
          }

          let tasksForProject = projectsAndTasks.get(ProjectName);
          if (!tasksForProject.some((task: { value: any; }) => task.value === TaskId)) {
            this.TaskOption = tasksForProject.push({
              label: Task,
              value: parseInt(TaskId)
            });
          }
        });

        this.demoOptions = Array.from(projectsAndTasks.entries()).map(([key, value]) => {
          const projectData = res.data.find((item: { project: { data: { name: string; }; }; }) => item.project.data.name === key);
          const projectId = projectData ? projectData.project.data.id : null;
          return {
            label: key,
            value: parseInt(projectId),
            tasks: value
          };
        });

        //  now transformData runs safely, 
        const transformedData = this.transformData(timesheet.Data);
        transformedData.billable.forEach(item => this.projects.push(item));
        transformedData.nonBillable.forEach(item => this.nonBillprojects.push(item));

        //  matching against demoOptions 
        if (this.projects.length != 0) {
          this.projects.forEach((project) => {
            const projectData = this.demoOptions.find(option => option.value === project.ProjectID);
            if (projectData) {
              project.TaskOptions = projectData.tasks;
            } else {
              project.TaskOptions = [];
              project.unavailable = true;
            }
          });
        } else {
          this.addNewProject();
        }

        if (this.nonBillprojects.length == 0) {
          this.addNewNonBillProject();
        }

        this.calculateNonBillTotalHours();
        this.calculateTotalHour();
        this.formatDatesbillable();
        this.formatDatesNonbillable();

        this.showLoader = false;
      },
      error: (error: any) => {
        this.showLoader = false;
        console.log('Error loading timesheet data', error);
      }
    });

    this.getAppConfiguration();
  }
  rowIdCounter: number = 0;
  generateRowId(rowIndex: number): string {
    return `projectRow_${rowIndex}`;
  }

  getWeekDays(date: Date) {
    const days: string[] = [];

    // Normalize to UTC midnight to avoid any timezone shift
    const utcDate = new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    ));

    // getUTCDay(): 0=Sunday, 1=Monday ... 6=Saturday
    const dayOfWeek = utcDate.getUTCDay();

    // Find Monday: if Sunday (0), go back 6 days, else go back (dayOfWeek - 1)
    const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    utcDate.setUTCDate(utcDate.getUTCDate() - daysToMonday);

    for (let i = 0; i < 7; i++) {
      const day = utcDate.getUTCDate().toString().padStart(2, '0');
      const month = (utcDate.getUTCMonth() + 1).toString().padStart(2, '0');
      const year = utcDate.getUTCFullYear();
      const formattedDate = `${day}/${month}/${year}`;

      if (i === 0) {
        this.Startweek = new Date(Date.UTC(year, utcDate.getUTCMonth(), utcDate.getUTCDate()));
      }
      if (i === 6) {
        this.Endweek = new Date(Date.UTC(year, utcDate.getUTCMonth(), utcDate.getUTCDate()));
      }

      days.push(formattedDate);
      utcDate.setUTCDate(utcDate.getUTCDate() + 1);
    }

    return days;
  }


  navigatePreviousWeek() {
    this.currentDate.setDate(this.currentDate.getDate() - 7); // Move back 7 days
    this.weekDays = this.getWeekDays(new Date(this.currentDate)); // Generate new week days
  }

  navigateNextWeek() {
    this.currentDate.setDate(this.currentDate.getDate() + 7); // Move forward 7 days
    this.weekDays = this.getWeekDays(new Date(this.currentDate)); // Generate new week days
  }

  navigateCurrentWeek() {
    this.currentDate = (new Date());
    this.weekDays = this.getWeekDays(this.currentDate);
  }

  navigateNonBillPreviousWeek() {
    this.currentDate.setDate(this.currentDate.getDate() - 7); // Move back 7 days
    this.nonBillweekDays = this.getWeekDays(new Date(this.currentDate)); // Generate new week days
  }

  navigateNonBillNextWeek() {
    this.currentDate.setDate(this.currentDate.getDate() + 7); // Move forward 7 days
    this.nonBillweekDays = this.getWeekDays(new Date(this.currentDate)); // Generate new week days
  }

  navigateNonBillCurrentWeek() {
    this.currentDate = (new Date());
    this.nonBillweekDays = this.getWeekDays(this.currentDate);
  }

  formatDate(date: Date) {
    const day = date.toLocaleDateString('en-US', { weekday: 'short' });
    const dateStr = date.getDate().toString().padStart(2, '0');
    return `${day} ${dateStr}`;
  }

  addNewProject() {
    if (!this.canAddTask) return;

    const lastProject = this.projects[this.projects.length - 1];

    if (lastProject != undefined) {
      if (lastProject.ProjectID && lastProject.TaskID && lastProject.TaskDetails) {
        const newProject: Project = {
          UserID: this.LoggedInUserId,
          UserName: this.LoggedInUserName,
          UserEmail: this.LoggedInUserEmail,
          ProjectID: '',
          ProjectName: '',
          TaskID: '',
          TaskName: '',
          comment: '',
          TimeCode: '178407',
          Hours: 0,
          StartWeek: this.Startweek,
          EndWeek: this.Endweek,
          IsBillable: 'Yes',
          showTaskOptions: false,
          TaskOptions: [],
          RecordStatus: '',
          TaskDetails: {},
          unavailable: false

        };

        // Initialize each day with DayDetails having empty 'hours' and 'comment'
        this.weekDays.forEach(day => {
          const parts = day.match(/\d+/g)!;
          if (parts && parts.length >= 3) {
            const parsedDate = new Date(+parts[2], +parts[1] - 1, +parts[0]);
            this.formattedDate = this.datePipe.transform(parsedDate, 'yyyy-MM-dd') || '';
          }

          newProject.TaskDetails[day] = {
            TimesheetDate: this.formattedDate,
            Hours: '',
            Comments: ''
          };
        });

        // this.TaskOptions = [];
        this.newRow = true
        this.projects.push(newProject);

      } else {
        this.emptyRowWarningVisible = true;
      }
    } else {

      const newProject: Project = {
        UserID: this.LoggedInUserId,
        UserName: this.LoggedInUserName,
        UserEmail: this.LoggedInUserEmail,
        ProjectID: '',
        ProjectName: '',
        TaskID: '',
        TaskName: '',
        comment: '',
        TimeCode: '178407',
        Hours: 0,
        StartWeek: this.Startweek,
        EndWeek: this.Endweek,
        IsBillable: 'Yes',
        showTaskOptions: false,
        TaskOptions: [],
        RecordStatus: '',
        TaskDetails: {},
        unavailable: false
      };

      // Initialize each day with DayDetails having empty 'hours' and 'comment'
      this.weekDays.forEach(day => {
        const parts = day.match(/\d+/g)!;
        if (parts && parts.length >= 3) {
          const parsedDate = new Date(+parts[2], +parts[1] - 1, +parts[0]);
          this.formattedDate = this.datePipe.transform(parsedDate, 'yyyy-MM-dd') || '';
        }

        newProject.TaskDetails[day] = {
          TimesheetDate: this.formattedDate,
          Hours: '',
          Comments: ''
        };
      });

      this.newRow = true
      this.projects.push(newProject);
    }
  }

  addNewNonBillProject() {

    if (!this.canAddTask) return;

    const lastProject = this.nonBillprojects[this.nonBillprojects.length - 1];
    if (lastProject != undefined) {
      if (lastProject.TaskID && lastProject.TaskDetails) {
        const newProject: Project = {
          UserID: this.LoggedInUserId,
          UserName: this.LoggedInUserName,
          UserEmail: this.LoggedInUserEmail,
          ProjectID: '0',
          ProjectName: '',
          TaskID: '',
          TaskName: '',
          comment: '',
          TimeCode: '179469',
          Hours: 0,
          StartWeek: this.Startweek,
          EndWeek: this.Endweek,
          IsBillable: 'No',
          showTaskOptions: false,
          TaskOptions: this.nonbillTasks,
          RecordStatus: '',
          TaskDetails: {},
          unavailable: false
        };

        // Initialize each day with DayDetails having empty 'hours' and 'comment'
        this.nonBillweekDays.forEach(day => {
          const parts = day.match(/\d+/g)!;
          if (parts && parts.length >= 3) {
            const parsedDate = new Date(+parts[2], +parts[1] - 1, +parts[0]);
            this.formattedDate = this.datePipe.transform(parsedDate, 'yyyy-MM-dd') || '';
          }

          newProject.TaskDetails[day] = {
            TimesheetDate: this.formattedDate,
            Hours: '',
            Comments: ''
          };
          // }
        });

        this.nonBillprojects.push(newProject);
      } else {
        this.emptyRowWarningVisible = true;
      }
    } else {
      const newProject: Project = {
        UserID: this.LoggedInUserId,
        UserName: this.LoggedInUserName,
        UserEmail: this.LoggedInUserEmail,
        ProjectID: '0',
        ProjectName: '',
        TaskID: '',
        TaskName: '',
        comment: '',
        TimeCode: '179469',
        Hours: 0,
        StartWeek: this.Startweek,
        EndWeek: this.Endweek,
        IsBillable: 'No',
        showTaskOptions: false,
        TaskOptions: this.nonbillTasks,
        RecordStatus: '',
        TaskDetails: {},
        unavailable: false
      };

      // Initialize each day with DayDetails having empty 'hours' and 'comment'
      this.nonBillweekDays.forEach(day => {
        const parts = day.match(/\d+/g)!;
        if (parts && parts.length >= 3) {
          const parsedDate = new Date(+parts[2], +parts[1] - 1, +parts[0]);
          this.formattedDate = this.datePipe.transform(parsedDate, 'yyyy-MM-dd') || '';
        }

        newProject.TaskDetails[day] = {
          TimesheetDate: this.formattedDate,
          Hours: '',
          Comments: ''
        };
      });

      this.nonBillprojects.push(newProject);
    }
  }

  showDialog(project: any, day: string) {
    if (project.IsBillable == "Yes") {
      this.currentProject = project;
      this.currentDay = day;
      this.tempHours = project.TaskDetails[day]?.Hours;
      this.tempComment = project.TaskDetails[day]?.Comments;
      this.visible = true;
    } else {
      this.currentProject = project;
      this.currentDay = day;
      this.tempHours = project.TaskDetails[day]?.Hours;
      this.tempComment = project.TaskDetails[day]?.Comments;
      this.nonBillvisible = true;
    }
  }

  submitDialog() {
    const parts = this.currentDay.match(/\d+/g)!;
    if (parts && parts.length >= 3) {
      const parsedDate = new Date(+parts[2], +parts[1] - 1, +parts[0]);
      this.formattedDate = this.datePipe.transform(parsedDate, 'yyyy-MM-dd') || '';
    }
    if (this.currentProject && this.currentProject.TaskDetails && this.currentProject.TaskDetails[this.currentDay]) {
      this.currentProject.TaskDetails[this.currentDay].TimesheetDate = this.formattedDate;
    }
    this.currentProject.TaskDetails[this.currentDay].Hours = this.tempHours;
    this.currentProject.TaskDetails[this.currentDay].Comments = this.tempComment;

    this.visible = false;
  }

  submitNonBillDialog() {
    if (!this.currentProject.TaskDetails) {
      this.currentProject.TaskDetails = {};
    }

    const parts = this.currentDay.match(/\d+/g)!; // Extract numeric parts of the date
    if (parts && parts.length >= 3) {
      const parsedDate = new Date(+parts[2], +parts[1] - 1, +parts[0]);
      this.formattedDate = this.datePipe.transform(parsedDate, 'yyyy-MM-dd') || '';
    }
    if (this.currentProject && this.currentProject.TaskDetails && this.currentProject.TaskDetails[this.currentDay]) {
      this.currentProject.TaskDetails[this.currentDay].TimesheetDate = this.formattedDate;
    }

    this.currentProject.TaskDetails[this.currentDay].Hours = this.tempHours;
    this.currentProject.TaskDetails[this.currentDay].Comments = this.tempComment;

    this.nonBillvisible = false; // Close the dialog
  }

  calculateTotalHours(TaskDetails: { [key: string]: DayDetails }): number {
    return Object.values(TaskDetails).reduce((total, currentDay) => {
      const hours = typeof currentDay.Hours === 'number' ? currentDay.Hours : parseFloat(currentDay.Hours);
      return total + (isNaN(hours) ? 0 : hours);
    }, 0);
  }

  format1Date(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  handleTaskChange(TaskID: any, rowIndex: any, IsBillable: any, projectData: any): void {
    // if (!TaskID) {
    this.showLoader = true;
    if (IsBillable == "Yes") {
      let project = this.projects[rowIndex];
      this.weekDays.forEach(day => {
        if (project.TaskDetails[day]) {
          project.TaskDetails[day].Hours = '';
          project.TaskDetails[day].Comments = '';
        }
      });
    } else {
      if (TaskID != null) {
        const task = this.nonbillTasks.find((t: { TaskId: any; }) => t.TaskId === TaskID);
        projectData.TaskName = task.Taskname;
      }
      let project = this.nonBillprojects[rowIndex];
      // Assuming weekDays is accessible here, iterate and clear hours
      this.nonBillweekDays.forEach(day => {
        if (project.TaskDetails[day]) {
          project.TaskDetails[day].Hours = '';
          project.TaskDetails[day].Comments = '';
        }
      });
    }
    this.cdr.detectChanges();
    // }
    if (TaskID === null || TaskID === undefined) {
      this.weekDays.forEach((day: string) => {
        const currentDate = new Date(day.split('/').reverse().join('-')); // Convert to 'YYYY-MM-DD' format
        this.rowDisabledStates[`${day}-${rowIndex}`] = false
      });
      this.showLoader = false;
    } else {
      if (IsBillable == "Yes") {
        this.TimesheetService.GetTasks(this.LoggedInUserId).subscribe((res: any) => {
          res.data.forEach((element: any) => {
            if (element.id == TaskID) {
              this.startDate = new Date(element.plannedStart);
              this.FinishDate = new Date(element.plannedFinish);;
              //  this.startDate = new Date('2024-04-02');
              // this.FinishDate = new Date('2024-04-06');
              this.weekDays.forEach((day: string) => {
                const currentDate = new Date(day.split('/').reverse().join('-')); // Convert to 'YYYY-MM-DD' format
                this.rowDisabledStates[`${day}-${rowIndex}`] =
                  currentDate < this.startDate || currentDate > this.FinishDate;
              });

              projectData.TaskName = element.name;
              this.showLoader = false;
              // const formattedStartweek = typeof this.Startweek === 'string' ? this.Startweek : this.format1Date(this.Startweek);//2024-04-01
              // const formattedEndweek = typeof this.Endweek === 'string' ? this.Endweek : this.format1Date(this.Endweek);//2024-04-07
              // const formattedStartDate = typeof this.startDate === 'string' ? this.startDate : this.format1Date(this.startDate);//2024-04-01
              // const formattedEndDate = typeof this.FinishDate === 'string' ? this.FinishDate : this.format1Date(this.FinishDate);//2024-04-04
              // const startDateWithinRange = formattedStartDate >= formattedStartweek && formattedStartDate <= formattedEndweek;
              // const endDateWithinRange = formattedEndDate >= formattedStartweek && formattedEndDate <= formattedEndweek;         
              //  Check if TaskID is null or undefined, then enable the row        
              //this.rowDisabledStates[rowIndex]= !(startDateWithinRange || endDateWithinRange);
              // if(this.rowDisabledStates[day]==true){
              //   this.messageService.add({ severity: 'warn', summary: '', detail: 'Planned project date is expired.' });
              // }
            }
          });
        });
      }
      else {
        this.showLoader = false;
      }

    }
    // this.showLoader=false;
  }

  @ViewChildren('inputHour') inputHourElements!: QueryList<ElementRef>;
  BH: number = 0;

  calculateTotalHour(): void {
    let sumHours = 0;
    if (this.inputHourElements != undefined || this.inputHourElements != null) {
      this.inputHourElements.forEach(inputElement => {
        const inputValue = parseFloat(inputElement.nativeElement.value);
        sumHours += isNaN(inputValue) ? 0 : inputValue;
      });
      this.BH = sumHours;
    }
  }

  @ViewChildren('nonBillInputHour') nonBillInputHourElements!: QueryList<ElementRef>;
  NBH: number = 0;

  calculateNonBillTotalHours(): void {
    let nonBillSumHours = 0;
    if (this.nonBillInputHourElements != undefined || this.nonBillInputHourElements != null) {
      this.nonBillInputHourElements.forEach(inputElement => {
        const inputValue = parseFloat(inputElement.nativeElement.value);
        nonBillSumHours += isNaN(inputValue) ? 0 : inputValue;
      });
      this.NBH = nonBillSumHours;
    }

  }

  totalHours: any
  saveData() {
    // this.calculateNonBillTotalHours()
    // this.calculateTotalHour()
    // if (this.BH + this.NBH > 40) {
    //   this.totalHours = this.BH + this.NBH;
    //   this.warningVisible=true;
    //   // this.showSuccessDialog()

    // } else {
    //   console.log('saveData')

    if (this.isAnyIDEmpty(this.projects) && this.isAnyIDEmpty(this.nonBillprojects)) {
      this.alertVisible = true;
    } else {
      this.showLoader = true;
      if (this.projects.length == 0) {
        const newProject: Project = {
          UserID: this.LoggedInUserId,
          UserName: this.LoggedInUserName,
          UserEmail: this.LoggedInUserEmail,
          ProjectID: '',
          ProjectName: '',
          TaskID: '',
          TaskName: '',
          comment: '',
          TimeCode: '178407',
          Hours: 0,
          StartWeek: this.Startweek,
          EndWeek: this.Endweek,
          IsBillable: 'Yes',
          showTaskOptions: false,
          TaskOptions: [],
          RecordStatus: '',
          TaskDetails: {},
          unavailable: false
        };

        this.weekDays.forEach(day => {
          const parts = day.match(/\d+/g)!;
          if (parts && parts.length >= 3) {
            const parsedDate = new Date(+parts[2], +parts[1] - 1, +parts[0]);
            this.formattedDate = this.datePipe.transform(parsedDate, 'yyyy-MM-dd') || '';
          }

          newProject.TaskDetails[day] = {
            TimesheetDate: this.formattedDate,
            Hours: '',
            Comments: ''
          };
        });

        this.projects.push(newProject);

      }
      if (this.nonBillprojects.length == 0) {
        const newProject: Project = {
          UserID: this.LoggedInUserId,
          UserName: this.LoggedInUserName,
          UserEmail: this.LoggedInUserEmail,
          ProjectID: '0',
          ProjectName: '',
          TaskID: '',
          TaskName: '',
          comment: '',
          TimeCode: '179469',
          Hours: 0,
          StartWeek: this.Startweek,
          EndWeek: this.Endweek,
          IsBillable: 'No',
          showTaskOptions: false,
          TaskOptions: this.nonbillTasks,
          RecordStatus: '',
          TaskDetails: {},
          unavailable: false
        };

        this.nonBillweekDays.forEach(day => {
          const parts = day.match(/\d+/g)!;
          if (parts && parts.length >= 3) {
            const parsedDate = new Date(+parts[2], +parts[1] - 1, +parts[0]);
            this.formattedDate = this.datePipe.transform(parsedDate, 'yyyy-MM-dd') || '';
          }

          newProject.TaskDetails[day] = {
            TimesheetDate: this.formattedDate,
            Hours: '',
            Comments: ''
          };
        });
        this.nonBillprojects.push(newProject);
      }

      let hasZeroHours = false;
      let hasNonBillZeroHours = false;
      for (var i = 0; i < this.projects.length; i++) {
        // this.projects[i].
        for (const date in this.projects[i].TaskDetails) {
          if (this.projects[i].TaskDetails.hasOwnProperty(date)) {
            // Check if the Hours property for the current date is 0
            if (this.projects[i].TaskDetails[date].Hours === 0 || this.projects[i].TaskDetails[date].Hours === '0') {
              // Set hasZeroHours to true if Hours is 0 for any date
              hasZeroHours = true;
              // break; // Exit the loop early since we found a date with 0 hours
            }
          }
        }
      }

      for (var j = 0; j < this.nonBillprojects.length; j++) {
        // this.projects[i].
        for (const date in this.nonBillprojects[j].TaskDetails) {
          if (this.nonBillprojects[j].TaskDetails.hasOwnProperty(date)) {
            // Check if the Hours property for the current date is 0
            if (this.nonBillprojects[j].TaskDetails[date].Hours === 0 || this.nonBillprojects[j].TaskDetails[date].Hours === '0') {
              // Set hasZeroHours to true if Hours is 0 for any date
              hasNonBillZeroHours = true;
              // break; // Exit the loop early since we found a date with 0 hours
            }
          }
        }
      }

      if (hasZeroHours || hasNonBillZeroHours) {
        // alert("O hours are there in object");
        this.hourWarningVisible = true;
        this.showLoader = false;
      } else {
        const data = JSON.stringify({ projects: this.projects, nonBillprojects: this.nonBillprojects });

        this.TimesheetService.AddTimeSheetDetail(data).subscribe({
          next: (data: any) => {
            this.ngOnInit();
            this.showLoader = false;
            this.MessageVisible = true;
          }, error: (error: any) => {
            this.showLoader = false;
            console.log('saveData return Failure')
          }
        });
      }
      // const data = JSON.stringify({ projects: this.projects, nonBillprojects: this.nonBillprojects });

      // this.TimesheetService.AddTimeSheetDetail(data).subscribe({
      //   next: (data: any) => {
      //     this.ngOnInit();
      //     this.showLoader = false;
      //     this.MessageVisible = true;
      //   }, error: (error: any) => {
      //     this.showLoader = false;
      //     console.log('saveData return Failure')
      //   }
      // });
    }
  }

  isAnyIDEmpty(projects: Project[]): boolean {
    return projects.some(project => {
      // Check if there are any hours logged for this project.
      const hasLoggedHours = Object.values(project.TaskDetails || {}).some(detail => +detail.Hours > 0);

      if (project.IsBillable === "No") {
        // For nonbillable projects, only check TaskID when hours are logged.
        return !hasLoggedHours || !project.TaskID;
      } else {
        // For billable projects, ensure both ProjectID and TaskID are present.
        return !project.ProjectID || !project.TaskID;
      }
    });
  }

  onProjectChange(projectId: any, project: any) {
    this.newRow = false;
    const selectedProject = this.demoOptions.find(option => option.value === projectId);
    let selectedProjectTasks: any;
    if (selectedProject) {
      project.TaskOptions = selectedProject.tasks;
      project.ProjectName = selectedProject.label;
    } else {
      project.TaskOptions = [];
    }

    this.weekDays.forEach(day => {
      if (project.TaskDetails[day]) {
        project.TaskDetails[day].Hours = '';
        project.TaskDetails[day].Comments = '';
      }
    });

    this.cdr.detectChanges();
    if (!projectId) {
      this.newRow = true
    }

    project.showTaskOptions = true;
  }

  ////COMMENTED DUE TO PREVIOUS IMPLEMENTATION COMMENTED, NEW IMPLEMENTATION INTRODUCED TO DEAL WITH UNASSIGNED ProjectId ERROR 
  // getTimesheet(userid: any, startweek: any, endweek: any) {
  //   this.TimesheetService.GetTimeSheet(userid, startweek, endweek).subscribe((response: any) => {
  //     const data = response.Data;


  //     const transformedData = this.transformData(data);
  //     this.projects = []; // Clear current projects before adding new ones
  //     this.nonBillprojects = []; // Clear current nonBillprojects before adding new ones

  //     transformedData.billable.forEach(item => {

  //       this.projects.push(item);
  //     });

  //     transformedData.nonBillable.forEach(item => {
  //       this.nonBillprojects.push(item);
  //     });

  //     if (this.projects.length != 0) {
  //       this.projects.forEach((project) => {
  //         const projectData = this.demoOptions.find(option => option.value === project.ProjectID);
  //         if (projectData) {
  //           project.TaskOptions = projectData.tasks;
  //         }
  //       });
  //     }
  //   });
  // }


  private transformData(rawData: any[]): TransformDataResult {
    const result: TransformDataResult = {
      billable: [],
      nonBillable: [],
    };

    if (rawData != null) {

      rawData.forEach(entry => {
        const isBillable = entry.IsBillable === 't';
        const targetArray = isBillable ? result.billable : result.nonBillable;

        let projectOrTaskIndex = targetArray.findIndex(p => p.TaskID === entry.TaskID && (isBillable ? p.ProjectID === entry.ProjectID : true));
        let projectOrTask: any;

        if (projectOrTaskIndex === -1) {
          const newProjectOrTask: Project = {
            UserID: this.LoggedInUserId,
            UserName: this.LoggedInUserName,
            UserEmail: this.LoggedInUserEmail,
            ProjectID: isBillable ? entry.ProjectID : 0,
            ProjectName: entry.ProjectName,
            TaskID: entry.TaskID,
            TaskName: entry.TaskName,
            comment: '',
            TimeCode: isBillable ? '178407' : '179469',
            Hours: 0,
            IsBillable: isBillable ? 'Yes' : 'No',
            StartWeek: this.Startweek,
            EndWeek: this.Endweek,
            showTaskOptions: true,
            TaskOptions: isBillable ? [] : this.nonbillTasks,
            RecordStatus: entry.RecordStatus,
            TaskDetails: {},
            unavailable: false

          };
          this.weekDays.forEach(day => {

            const parts = day.match(/\d+/g)!;
            if (parts && parts.length >= 3) {
              const parsedDate = new Date(+parts[2], +parts[1] - 1, +parts[0]);
              this.formattedDate = this.datePipe.transform(parsedDate, 'yyyy-MM-dd') || '';
            }
            newProjectOrTask.TaskDetails[day] = {
              TimesheetDate: this.formattedDate,
              Hours: '',
              Comments: ''
            };
          });
          targetArray.push(newProjectOrTask);
          projectOrTaskIndex = targetArray.length - 1; // Update index to the newly added item
        }
        else {
          // Update RecordStatus if already exists
          // If any row is NOT Pending, reflect that
          const existingStatus = targetArray[projectOrTaskIndex].RecordStatus?.trim();
          const incomingStatus = entry.RecordStatus?.trim();
          if (existingStatus === 'Pending' && incomingStatus !== 'Pending') {
            targetArray[projectOrTaskIndex].RecordStatus = incomingStatus;
          }
        }

        projectOrTask = targetArray[projectOrTaskIndex];

        const dateKey = entry.TimesheetDate.split('T')[0];
        const parts = dateKey.match(/\d+/g)!; // Extract numeric parts of the date
        if (parts && parts.length >= 3) {
          // Assuming DD/MM/YYYY format for the parts
          const parsedDate = new Date(+parts[2], +parts[1] - 1, +parts[0]);
          this.formattedDate = this.datePipe.transform(parsedDate, 'yyyy-MM-dd') || '';
        }

        projectOrTask.TaskDetails[dateKey] = {
          TimesheetDate: this.formattedDate,
          Hours: entry.Hours || 0,
          Comments: entry.Comments || '',
        };

      });
    }

    return result;
  }

  clearValues(project: any, day: string) {
    this.confirmationService.confirm({
      target: event?.target as EventTarget,
      message: 'Do you want to delete this data?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button-danger p-button-text",
      rejectButtonStyleClass: "p-button-text p-button-text",
      acceptIcon: "none",
      rejectIcon: "none",

      accept: () => {
        this.currentProject = project;
        this.currentDay = day;

        this.tempHours = "";
        this.tempComment = "";
        this.currentProject.TaskDetails[this.currentDay].Hours = this.tempHours;
        this.currentProject.TaskDetails[this.currentDay].Comments = this.tempComment;
      },
      reject: () => {
        // this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected' });
      }
    });
    // this.currentProject = project;
    // this.currentDay = day;

    // this.tempHours = "";
    // this.tempComment = "";
    // this.currentProject.TaskDetails[this.currentDay].Hours = this.tempHours;
    // this.currentProject.TaskDetails[this.currentDay].Comments = this.tempComment;
  }

  removeProject(rowIndex: number, isbillable: any): void {
    if (!this.canAddTask) return;

    this.confirmationService.confirm({
      target: event?.target as EventTarget,
      message: 'Do you want to delete this row?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button-danger p-button-text",
      rejectButtonStyleClass: "p-button-text p-button-text",
      acceptIcon: "none",
      rejectIcon: "none",

      accept: () => {
        if (isbillable == "Yes") {
          this.projects.splice(rowIndex, 1);
        } else {
          this.nonBillprojects.splice(rowIndex, 1);
        }
      },
      reject: () => {

      }
    });
  }

  formatDatesbillable() {
    const weekdaysFormatted = this.weekDays.map(dateString => {
      const [dd, mm, yyyy] = dateString.split("/").map(Number);

      // Use UTC methods directly — no string parsing, no timezone shift
      const date = new Date(Date.UTC(yyyy, mm - 1, dd));

      const day = date.toLocaleDateString('en-US', { weekday: 'short', timeZone: 'UTC' });
      const dateNum = date.toLocaleDateString('en-US', { day: '2-digit', timeZone: 'UTC' });

      return `${dateNum} ${day}`;
    });
    this.formattedWeekDaysbillable = weekdaysFormatted;
  }

  formatDatesNonbillable() {
    const weekdaysFormatted = this.weekDays.map(dateString => {
      const [dd, mm, yyyy] = dateString.split("/").map(Number);

      const date = new Date(Date.UTC(yyyy, mm - 1, dd));

      const day = date.toLocaleDateString('en-US', { weekday: 'short', timeZone: 'UTC' });
      const dateNum = date.toLocaleDateString('en-US', { day: '2-digit', timeZone: 'UTC' });

      return `${dateNum} ${day}`;
    });
    this.formattedWeekDaysNonbillable = weekdaysFormatted;
  }

  formatDateNew(dateString: string | number | Date) {
    const raw = new Date(dateString);

    // Normalize to UTC (already UTC from getWeekDays, but safe to do anyway)
    const date = new Date(Date.UTC(
      raw.getUTCFullYear(),
      raw.getUTCMonth(),
      raw.getUTCDate()
    ));

    const day = date.toLocaleDateString('en-IN', { day: '2-digit', timeZone: 'UTC' });
    const month = date.toLocaleDateString('en-IN', { month: 'short', timeZone: 'UTC' });
    const year = date.toLocaleDateString('en-IN', { year: '2-digit', timeZone: 'UTC' });

    return `${day} ${month} ${year}`;
  }

  onTempHoursChange(event: any): void {
    const newValue = parseFloat(event.target.value);

    if (newValue < 0.5 || isNaN(newValue)) {
      this.hourWarningVisible = true;
      this.tempHours = ''; // Reset to a valid default value
    } else {
      this.hourWarningVisible = false;
    }
  }

  onNonBillableHoursChange(value: string, day: string, index: number): void {
    const newValue = parseFloat(value);

    if (newValue < 0.5) {
      this.hourWarningVisible = true;
      this.nonBillprojects[index].TaskDetails[day].Hours = ''; // Reset to a valid default value
    } else {
      this.hourWarningVisible = false;
      if (!isNaN(newValue)) {
        this.nonBillprojects[index].TaskDetails[day].Hours = newValue;
      } else {
        this.nonBillprojects[index].TaskDetails[day].Hours = '';
      }
      // this.nonBillprojects[index].TaskDetails[day].Hours = newValue;
    }
    this.cdr.detectChanges();
  }

  onBillableHoursChange(value: string, day: string, index: number, project: any): void {
    const newValue = parseFloat(value);

    if (newValue < 0.5) {
      // this.hourWarningVisible=true;
      this.projects[index].TaskDetails[day].Hours = ""; // Reset to a valid default value

      // // this.currentProject = project;
      // // this.currentDay = day;

      // // this.tempHours = "";
      // // this.tempComment = "";

      // // this.currentProject.TaskDetails[this.currentDay].Hours.setValue= this.tempHours;
      // // this.currentProject.TaskDetails[this.currentDay].Comments = this.tempComment;
      this.cdr.detectChanges();

      this.hourWarningVisible = true;

      // if (this.inputHour && this.inputHour.nativeElement) {
      //   this.inputHour.nativeElement.value = '';
      // }

    } else {
      this.hourWarningVisible = false;
      if (!isNaN(newValue)) {
        this.projects[index].TaskDetails[day].Hours = newValue;
      } else {
        this.projects[index].TaskDetails[day].Hours = '';
        // this.projects[index].TaskDetails[day]={TimesheetDate:day,Hours : '',Comments: ''}
      }
    }
  }
  getNonBillOptions() {
    this.TimesheetService.getNonBillOptions().subscribe({
      next: (data: any) => {
        //  this.nonbillTasks.TaskID = data.Data[0].TaskID
        //   this.nonbillTasks.TaskName = data.Data[0].NonBillableTask
        // this.nonbillTasks = [
        //   { Taskname: data.Data[0].NonBillableTask, TaskId: data.Data[0].TaskID }]
        this.nonbillTasks = data.Data.map((item: { NonBillableTask: any; TaskID: any; }) => ({
          Taskname: item.NonBillableTask,
          TaskId: item.TaskID
        }));

        // // console.log(this.nonbillTasks)
        // this.showLoader = false;
        // this.MessageVisible = true;
      }, error: (error: any) => {
        this.showLoader = false;
        console.log('get Nonbill options return Failure')
      }
    });
  }

  getAppConfiguration() {
    this.TimesheetService.getAppConfiguration().subscribe({
      next: (data: any) => {
        this.configData = data.Data;
        this.serverTime = data.Data[0].ServerTime;
        const isDataProcessingRunning = this.configData.find((x: { KeyName: string; }) => x.KeyName.toLocaleLowerCase() === 'IsDataProcessingRunning'.toLocaleLowerCase())?.KeyValue;
        const isDataProcessingRunningNotification = this.configData.find((x: { KeyName: string; }) => x.KeyName.toLocaleLowerCase() === 'IsDataProcessingRunningNotification'.toLocaleLowerCase())?.KeyValue;

        this.isDataProcessing = isDataProcessingRunning;
        this.dataProcessingNote = isDataProcessingRunningNotification
      }, error: (error: any) => {
        this.showLoader = false;
      }
    });
  }
}